import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import firebase from "firebase";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

Sentry.init({
  dsn:
    "https://3204579bbfc046ea8b30aaf7b450e371@o327458.ingest.sentry.io/5575129",
  autoSessionTracking: true,
  integrations: [new Integrations.BrowserTracing()],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

// firebase setup
try {
  if (!firebase.apps.length) {
    firebase.initializeApp({
      apiKey: "AIzaSyDji97_q8pNkT20I0JQVA3sdvT4r6rTa5M",
      authDomain: "student-discount.firebaseapp.com",
      projectId: "student-discount",
      storageBucket: "student-discount.appspot.com",
      messagingSenderId: "626026849141",
      appId: "1:626026849141:web:5df2a6da0393e33d3ae93c",
      measurementId: "G-Z4X2BFC2RY",
    });
    firebase.analytics();
  }
} catch (error) {
  console.log(error);
}
export const db = firebase.firestore();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
